import { useRef, useState } from "react";
import { Tooltip } from "antd";

interface EllipsisTooltipProps {
  text: string;
  className?: string;
}

// 单行省略文本，仅在文本被截断时悬停展示气泡
export const EllipsisTooltip = ({ text, className }: EllipsisTooltipProps) => {
  const [overflow, setOverflow] = useState(false);
  const spanRef = useRef<HTMLSpanElement>(null);

  // 悬停时实时测量，避免容器宽度变化后判断失效
  const handleMouseEnter = () => {
    const el = spanRef.current;
    if (el) {
      setOverflow(el.scrollWidth > el.clientWidth);
    }
  };

  return (
    <Tooltip title={text} open={overflow ? undefined : false}>
      <span
        ref={spanRef}
        className={className}
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          display: "block",
          minWidth: 0,
        }}
        onMouseEnter={handleMouseEnter}
      >
        {text}
      </span>
    </Tooltip>
  );
};
